// ******************************************************
// FONCTIONS sur les DATES et les heures
// ******************************************************

// Les appels à l'API LSRest2 nécessitent des dates au format YYYY-MM-DD
// et retournent des dates au format ISO(?) ex : '2022-12-14T08:00:00'
export const today = ls2date(new Date());

export function ls2date(date, separateur = '-') {
  const newDate = new Date(date);
  //Attention : il faut un leading 0 pour les mois < 10 et il sont zero based, ainsi que pour les jours !
  let formated_date = [];
  formated_date.push(newDate.getFullYear());
  formated_date.push((newDate.getMonth() + 1).toString().padStart(2, '0'));
  formated_date.push(newDate.getDate().toString().padStart(2, '0'));
  formated_date = formated_date.join(separateur);
  return formated_date;
}

/**
 * AFFICHAGE DES DATES (et HEURES) FORMATÉES SUR L'AFFICHEUR
 * Pour les options voir :
 * https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * PRATIQUE : si on ne passe pas d'options pour les heures par exemple, on obtient une date formatée sans l'heure.
 * On peut jouer avec les options pour arriver au format souhaité.
 */
export function lsPrintDate(date) {
  // let options = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }; // Avec l'année
  let options = {weekday: 'short', day: 'numeric', month: 'short'}; // Sans l'année
  const newDate = new Date(date);
  //return newDate.toLocaleString('fr_FR',{weekday : 'short', month: 'short', year : '2-digit'})
  return newDate.toLocaleString(undefined, options);
}

export function lsPrintTime(date) {
  //let options = {weekday: "short", year: "2-digit", month: "short", day: "numeric"};
  let options = {hour: '2-digit', minute: 'numeric'};
  const newDate = new Date(date);
  //return newDate.toLocaleString('fr_FR',{weekday : 'short', month: 'short', year : '2-digit'})
  return newDate.toLocaleString(undefined, options);
}

// Cette fonction formate une date pour qu'elle soit affichée en "mois YYYY" ex : "avril 2023"
export function lsPrintMonth(date) {
  let options = {month: 'long', year: 'numeric'};
  const newDate = new Date(date);
  return newDate.toLocaleString(undefined, options);
}

// Fonction pour vérifier si une date fait partie d'un week-end
// Permet de mettre en évidence les week-end (et les sam et dim)
export function is_weekend(date) {
  let newDate = new Date(date).getDay();
  if (newDate === 0) {
    return 'we dim';
  } else if (newDate === 6) {
    return 'we sam';
  } else {
    return 'sem';
  }
}

/**
	 FORMATAGE DE LA DATE POUR LA CONSTRUCTION DES LIENS DE RÉSERVATION
	 Cette fonction formate la date et l'heure reçue par le WS
	 en une date (et heure) formatée pour les URL de réservation (set_args) 
	 La fonction retourne un tableau [date, heure] ex: [20230715, 715]
*/
export function date2set_args(date) {
  const newDate = new Date(date);
  //Attention : il faut un leading 0 pour les mois < 10 et il sont zero based, ainsi que pour les jours !
  let formated_date = [];
  let formated_time = [];
  formated_date.push(newDate.getFullYear());
  formated_date.push((newDate.getMonth() + 1).toString().padStart(2, '0'));
  formated_date.push(newDate.getDate().toString().padStart(2, '0'));
  formated_date = formated_date.join('');
  formated_time.push(newDate.getHours());
  formated_time.push(newDate.getMinutes().toString().padStart(2, '0'));
  formated_time = formated_time.join('');
  return [formated_date, formated_time];
}

/**
 * COMPARAISON DE 2 DATES
 * On veut comparer les dates retournées par l'API LSRest sans tenir compte des heures
 * Car dès que l'heure varie, même sur le même jour => 2 dates différentes.
 * On veut regrouper les horaires qui ont lieu le même jour
 */
export function lsDateCompare(date1, date2) {
  let newDate1 = new Date(date1).setHours(0, 0, 0, 0);
  let newDate2 = new Date(date2).setHours(0, 0, 0, 0);
  return newDate1 === newDate2;
}

/**
 * VÉRIFIER SI UN HORAIRE EST PASSÉ
 * @param {string} date ISO reçu par le WS : ex. : 2022-12-17T19:00
 */
export function horairePasse(date1) {
  let tstp1 = Date.parse(date1); // Timestamp
  let now = Date.now(); // Timestamp présent
  return tstp1 < now;
}

export function addDays(date, days) {
  //date = YYYY-MM-DD ou tout format supporté par le constructeur Date()
  let newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return ls2date(newDate);
}

// Fonction qui renvoie la date du dernier jour du mois de la date passée en paramètre.
// C'est le premier jour du mois suivant - 1 jour
// On la retourne formatée en YYYY-MM-DD, pour insertion dans les appels de l'API
export function end_of_month(date) {
  let newDate = new Date(date);
  newDate = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0, 2); // Date 0 pour le jour d'avant, 2 heure pour des raison de UTC et décalage horaire
  return ls2date(newDate);
}

// Suite au changement de ressource de l'API (LS_CROISIERE à la place de LS_STE_DEPART_CRO)
// on ne requête plus le dernier jour du mois mais le premier du mois suivant
export function first_of_next_month(date) {
  let newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + 1);
  newDate.setDate(1);
  return ls2date(newDate);
}

/**
 * On détermine quel doit être le premier mois à afficher dans le select en fonction de la date actuelle et de l'intervalle de saison déterminée par l'utilisateur. 
 Elle valorisera le premier choix du select des choix des mois. Attention : Nous recevons en paramères du client que le mois de début de la saison, pas l'année. Il y a une subtilité sur l'année. Ce n'est pas forcément l'année en cours. Ex si saison = [4,10], et qu'on joue cette fonction en décembre, la date de début de saison sera avril (4) mais en année n+1 !
 * @param {number} mois_debut_saison
 * @param {number} mois_fin_saison
 * @returns {array} Tableau ['YYYY-MM-DD', 'mois YYYY'] <<= on a besoin de ces 2 valeurs pour valoriser le select.
 */
export function get_date_debut_saison(mois_debut_saison, mois_fin_saison) {
  let date = new Date();
  date.setDate(1); // Important car si on consulte un 31 et que le mois suivant n'en a pas cela peut décaler de 2 mois au lieu d'un (voir plus bas)
  let mois_en_cours = date.getMonth() + 1; // On ne gère pas les mois en "zero based" ici
  if (mois_en_cours < mois_debut_saison) {
    date.setMonth(mois_debut_saison - 1);
    date.setDate(1);
  } else if (mois_en_cours > mois_fin_saison) {
    date.setFullYear(date.getFullYear() + 1);
    date.setMonth(mois_debut_saison - 1);
    date.setDate(1);
  } else {
    // On est dans la saison
    date.setDate(1);
  }
  return [ls2date(date), lsPrintMonth(date)];
}

/*
  Comparaison de 2 dates (passées au format '2023-04-08T15:45:00')
  Retourne la différence en ms
 */
export function compare_date(date1, date2) {
  date1 = new Date(date1);
  date2 = new Date(date2);
  return date2 - date1;
}

function addTrailingZeros(num, totalLength) {
  // permet d'ajouter un trailing "0" à un nombre.
  // on va s'en servir pour les durée de traversée : on ne veut pas afficher durée : 1:0, mais 1:00
  return String(num).padEnd(totalLength, '0');
}

export function ms2time(milliseconds) {
  const hours = Math.floor(milliseconds / 3600000);
  const minutes = Math.floor((milliseconds % 3600000) / 60000);
  //const seconds = Math.floor(((milliseconds % 360000) % 60000) / 1000);
  return `${hours}:${addTrailingZeros(minutes, 2)}`;
}
